<template>
<el-collapse v-model="isOpen">
    <el-collapse-item :title="$t('common.search')" name="cases-and-clims-search-section" id="cases-and-clims-search-section">
        <el-form
          id="customer-search-section-form"
          ref="searchForm"
          label-position="right"
          size="mini"
          class="search-section-form"
          inline
      >
      <!-- primera fila -->
          <el-row :gutter="10">
            <!--case number-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.caseNumber')" >
                <el-input v-model="form.caseNumber" :placeholder="$t('casesAndClaims.placeholder.caseNumber')" />
              </el-form-item>
            </el-col>

            <!--status-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.statusClaim')" >
                <status-claim-select :default-all="isInternalUser" :multiple="true" v-model="form.statusClaim"/>
              </el-form-item>
            </el-col>

            <!--claim-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.claim')" ><case-with-claim-select default-all v-model="form.claim"/>
              </el-form-item>
            </el-col>

            <!--invoice-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.invoice')" >
                <el-input v-model="form.invoiceNumber" :placeholder="$t('casesAndClaims.placeholder.invoiceNumber')" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- segunda fila -->
          <el-row :gutter="10">
            <!--pick up date-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.shipmentDate')" >
                <el-date-picker
                                v-model="form.shipmentDate"
                                class="custom-date-range"
                                style="width: 100%"
                                size="mini"
                                format="MM/dd/yyyy"
                                value-format="yyyy-MM-dd"
                                :clearable="true"
                                type="daterange"
                                range-separator="To"
                                start-placeholder="Start"
                                end-placeholder="End"
                            />
              </el-form-item>
            </el-col>
            <!--pick up date
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.pickupDate')" >
                <el-date-picker
                                v-model="form.pickupDate"
                                class="el-dropdown-new drop-sp date-dob"
                                :placeholder="$t('casesAndClaims.placeholder.pickupDate')"
                                size="mini"
                                format="MM/dd/yyyy"
                                value-format="yyyy-MM-dd"
                                :clearable="true"
                                type="date"
                            />
              </el-form-item>
            </el-col>
            -->
            <!--date opened-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.createdDate') || 'Date created'" >
                <el-date-picker
                                v-model="form.dateOpened"
                                class="custom-date-range"
                                style="width: 100%"
                                size="mini"
                                format="MM/dd/yyyy"
                                value-format="yyyy-MM-dd"
                                :clearable="true"
                                type="daterange"
                                range-separator="To"
                                start-placeholder="Start"
                                end-placeholder="End"
                            />
              </el-form-item>
            </el-col>

            <!--load number-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.loadNumber')" >
                <el-input v-model="form.loadNumber"  :placeholder="$t('casesAndClaims.placeholder.loadNumber')" />
              </el-form-item>
            </el-col>

            <!--bill to -->
            <el-col :span="6" v-if="!embedded || getAccountType() !== 'billTo'">
              <el-form-item :label="$t('casesAndClaims.billTo')" >
                <autocomplete
                    :model.sync="form.billTo"
                    :url="urlBillTo"
                    :placeholder="$t('casesAndClaims.placeholder.searchBillTo')"
                    labelField="name"
                    popperAppendToBody
                    labelFieldLastWithDash="number"
                    valueField="id"
                    ref="autocomplete-input-billTo"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- tercera fila -->
          <el-row :gutter="10">
            <!--shipper-->
            <el-col :span="6" v-if="!embedded || getAccountType() !== 'shipper'">
              <el-form-item :label="$t('casesAndClaims.shipper')" >
                <autocomplete
                                :model.sync="form.shipper"
                                :url="urlShipper"
                                :placeholder="$t('casesAndClaims.placeholder.shipper')"
                                labelField="name"
                                popperAppendToBody
                                labelFieldLastWithDash="number"
                                valueField="id"
                                ref="autocomplete-input-shipper"
                                />
              </el-form-item>
            </el-col>

            <!--consignee-->
            <el-col :span="6" v-if="!embedded || getAccountType() !== 'consignee'">
              <el-form-item :label="$t('casesAndClaims.consignee')" >
                <autocomplete
                                :model.sync="form.consignee"
                                :url="urlConsignee"
                                :placeholder="$t('casesAndClaims.placeholder.consignee')"
                                labelField="name"
                                popperAppendToBody
                                labelFieldLastWithDash="number"
                                valueField="id"
                                ref="autocomplete-input-consignee"
                                />
              </el-form-item>
            </el-col>

            <!--shipment number-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.shipment')" >
                <el-input v-model="form.shipment"  :placeholder="$t('casesAndClaims.placeholder.shipment')" />
              </el-form-item>
            </el-col>
            <!--subject-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.subject')" >
                <el-input v-model="form.subject"  :placeholder="$t('casesAndClaims.placeholder.subject')" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- cuarta fila -->
          <el-row :gutter="10">
            <!--Creator user-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.createdBy')" >
<!--                <autocomplete-->
<!--                                :model.sync="form.createdBy"-->
<!--                                :url="urlCreator"-->
<!--                                :placeholder="$t('casesAndClaims.placeholder.shipper')"-->
<!--                                labelField="name"-->
<!--                                popperAppendToBody-->
<!--                                labelFieldLastWithDash="code"-->
<!--                                valueField="id"-->
<!--                                ref="autocomplete-input-shipper"-->
<!--                                />-->
                <el-select
                    v-model="form.internal"
                    :placeholder="$t('casesAndClaims.createdBy')"
                >
                  <el-option
                      :value="null"
                      label="All"
                  > All </el-option>
                  <el-option
                      :value="true"
                      label="Internal User"
                  >
                    Internal User
                  </el-option>

                  <el-option
                      :value="false"
                      label="Customer"
                  >
                    Customer
                  </el-option>

                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Email sent" >
                <el-select
                    v-model="form.emailSent"
                    placeholder="Email sent"
                >
                  <el-option
                      :value="null"
                      label="All"
                  > All </el-option>
                  <el-option
                      :value="true"
                      label="Yes"
                  >
                    Yes
                  </el-option>

                  <el-option
                      :value="false"
                      label="No"
                  >
                   No
                  </el-option>

                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.caseOwner')" >
              <username-auto-complete
                  @selected="onUserSelected"
                  @cleared="onUserCleared"
              />
              </el-form-item>
            </el-col>
<!--            Posted date-->
            <el-col :span="6">
              <el-form-item :label="$t('casesAndClaims.postedDate')" >
                <el-date-picker
                    v-model="form.postedDate"
                    class="custom-date-range"
                    style="width: 100%"
                    size="mini"
                    format="MM/dd/yyyy"
                    value-format="yyyy-MM-dd"
                    :clearable="true"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start"
                    end-placeholder="End"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- quinta fila -->
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="Reconsignment Amount" >
                <el-select
                    v-model="form.reconsignmentAmount"
                    placeholder="Reconsignment Amount"
                >
                  <el-option
                      :value="null"
                      label="All"
                  > All </el-option>
                  <el-option
                      :value="true"
                      label="Yes"
                  >
                    Yes
                  </el-option>

                  <el-option
                      :value="false"
                      label="No"
                  >
                    No
                  </el-option>

                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Reconsignment Pending" >
                <el-select
                    v-model="form.reconsignmentPending"
                    placeholder="Reconsignment Pending"
                >
                  <el-option
                      :value="null"
                      label="All"
                  > All </el-option>
                  <el-option
                      :value="true"
                      label="Yes"
                  >
                    Yes
                  </el-option>

                  <el-option
                      :value="false"
                      label="No"
                  >
                    No
                  </el-option>

                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
            <el-tooltip
                :content="$t('common.search')"
                class="item"
                effect="dark"
                placement="top-start"
            >
              <el-button
                  id="customer-search-section-form-button"
                  @click="handleSearch"
                  class="button-action-default"
                  icon="el-icon-search"
                  size="mini"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>

        </el-form>
    </el-collapse-item>
</el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';
import { CASES_AND_CLAIMS_LIST_SEARCH } from '@/store/actions';
import UsernameAutoComplete from '@/views/customerCenter/casesAndClaims/components/usernameAutoComplete/UsernameAutoComplete';
import StatusClaimSelect from './components/statusClaimSelect/StatusClaimSelect';
import CaseWithClaimSelect from './components/caseWithClaimSelect/CaseWithClaimSelect';

export default {
  name: 'SearchFilter',
  components: {
    UsernameAutoComplete,
    StatusClaimSelect,
    CaseWithClaimSelect,
    Autocomplete
  },
  computed: {
    ...mapGetters(['casesAndClaims', 'isInternalUser']),
  },
  data() {
    return {
      isOpen: ['cases-and-clims-search-section'],
      form: {
        caseNumber: null,
        statusClaim: null,
        claim: null,
        invoiceNumber: null,
        pickupDate: null,
        postedDate: null,
        dateOpened: [],
        subject: null,
        shipmentDate: null,
        loadNumber: null,
        billTo: null,
        shipper: null,
        consignee: null,
        shipment: null,
        createdBy: null,
        internal: null,
        emailSent: null,
        reconsignmentAmount: null,
        reconsignmentPending: null,
        ownerName: null,
        ownerEmail: null
      },
      urlBillTo: apiConstants.END_POINTS.ACCOUNTS.BILL_TO,
      urlShipper: apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
      urlConsignee: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE,
      urlCreator: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE
    };
  },
  props: {
    embedded: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    account: {
      deep: true,
      handler(newVal) {
        // account arrives asynchronously when embedded in Armellini Profile / Customer Master
        // Record (the "Select Account" flow can mount this form before the account is ready) —
        // re-derive the account scoping as soon as real account data shows up, instead of relying
        // solely on the one-shot mounted() call below.
        if (this.embedded && newVal && newVal.id) {
          this.resetForm();
        }
      }
    }
  },
  mounted() {
    this.resetForm();
    if (!this.embedded) {
      this.handleGetAll();
    }
  },
  methods: {
    /**
     * Triggered by the @selected event from the child.
     * @param {Object} user - Contains { name, email }
     */
    onUserSelected(user) {
      this.form.ownerName = user.name;
      this.form.ownerEmail = user.email;
    },

    /**
     * Triggered by the @cleared event from the child.
     */
    onUserCleared() {
      this.form.ownerName = '';
      this.form.ownerEmail = '';
    },
    resetForm() {
      this.form = {
        caseNumber: null,
        statusClaim: null,
        claim: null,
        invoiceNumber: null,
        shipmentDate: null,
        pickupDate: null,
        dateOpened: [],
        subject: null,
        loadNumber: null,
        billTo: null,
        shipper: null,
        consignee: null,
        shipment: null,
        createdBy: null,
        internal: null,
        emailSent: null,
        ownerName: null,
        ownerEmail: null,
        reconsignmentAmount: null,
        reconsignmentPending: null
      };
      if (this.embedded) {
        const accountTypeKey = this.getAccountType();
        if (accountTypeKey && this.account && this.account.id) {
          this.form[accountTypeKey] = this.account.id;
        }
      }
    },
    getAccountType() {
      const typeVal = this.account && this.account.type ? this.account.type.toLowerCase() : null;
      if (typeVal === 'bill to' || typeVal === 'bill-to' || typeVal === 'bill_to') {
        return 'billTo';
      }
      return typeVal;
    },
    getAccountName() {
      return this.account ? `${this.account.name}-${this.account.number}` : '';
    },
    getAmountLabel() {
      return '';
    },
    getTotalAmount() {
      return 0;
    },
    handleSearch() {
      const payload = {
        ...this.form,
        shipmentDate: null,
        shipDateFrom: this.form.shipmentDate && this.form.shipmentDate.length ? this.form.shipmentDate[0] : null,
        shipDateTo: this.form.shipmentDate && this.form.shipmentDate.length ? this.form.shipmentDate[1] : null,
        dateOpenedFrom: this.form.dateOpened && this.form.dateOpened.length ? this.form.dateOpened[0] : null,
        dateOpenedTo: this.form.dateOpened && this.form.dateOpened.length ? this.form.dateOpened[1] : null,
        postedDateFrom: this.form.postedDate && this.form.postedDate.length ? this.form.postedDate[0] : null,
        postedDateTo: this.form.postedDate && this.form.postedDate.length ? this.form.postedDate[1] : null,
        orderField: null,
        createdBy: null,
        statusClaimList: this.form.statusClaim && this.form.statusClaim.length ? this.form.statusClaim.join() : null,
      };
      delete payload.dateOpened;
      delete payload.statusClaim;
      delete payload.postedDate;
      const queryKeys = Object.keys(payload);
      const keysUsed = queryKeys.filter(key => payload[key] !== null && payload[key] !== undefined && payload[key] !== '');
      payload.showTags = this.account && this.embedded ? keysUsed.length > 1 : keysUsed.length > 0; // if account is provided, at least 2 fields are needed to show tags (one of them is account), otherwise 1 field is enough
      this.$store.dispatch(CASES_AND_CLAIMS_LIST_SEARCH, payload);
    },
    handleGetAll() {
      // this.$store.dispatch(CASES_AND_CLAIMS_ALL, { ...this.form, orderField: null }); , CASES_AND_CLAIMS_ALLs
      this.handleSearch();
    }
  },
};
</script>

<style scoped>
::v-deep .custom-date-range .el-range-separator {
  width: auto !important;
  padding: 0 5px !important;
  min-width: 25px;
}
::v-deep .custom-date-range .el-range-input {
  width: 45%;
}
</style>
